<template>
  <!-- 账期调整申请待审批列表 -->
  <div class="approve-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="download" @click="downloadTable">
          下载表格
        </a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:specialNo="{ tableRow }">
          <span>{{ tableRow.specialNo.join(', ') }}</span>
        </template>

        <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template>

        <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template>

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="AUDIT_STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center"
          >
            {{ AUDIT_STATUS_OBJ[tableRow.status].text }}
          </a-tag>
        </template>

        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            审核
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { SEARCH_SCHEMA } from './schema'
import { getApproveList, downloadTermTable } from './api'
import { formatParamDate } from 'utils/util'
import { CREDIT_TYPE_OBJ } from '../const'
import { AUDIT_STATUS_OBJ } from './const'

export default {
  name: 'approve-list',
  data() {
    const initSearchForm = {
      name: '',
      code: '',
      endTime: '',
      startTime: '',
      id: '',
      source: '',
      sn: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      SEARCH_SCHEMA,
      CREDIT_TYPE_OBJ,
      AUDIT_STATUS_OBJ,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      approvalOrApply: null, //获取是审批页还是申请页
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '流水号',
          dataIndex: 'id',
          align: 'center',
          width: 190,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          width: 270,
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          width: 130,
        },
        {
          title: '申请人',
          dataIndex: 'applyPerson',
          width: 130,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          align: 'center',
          width: 120,
        },
        {
          title: '审批角色',
          dataIndex: 'applyRole',
          width: 120,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 120,
          align: 'center',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          align: 'center',
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1200 },
    }
  },
  mounted() {
    this._getAuditList(this.initSearchForm)
  },
  methods: {
    async downloadTable() {
      try {
        await downloadTermTable(this.searchForm)
      } catch (error) {
        console.error(error)
      }
    },
    // 点击查询按钮
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getAuditList(data)
    },
    //获取账期调整待审批列表
    async _getAuditList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getApproveList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getAuditList(this.searchForm)
    },
    handleView(row) {
      const { id, status, companyCode, sn } = row
      this.$router.push({
        path: `/credit-approval/approve/approve-detail/${id}`,
        query: {
          type: 1,
          status,
          companyCode,
          sn,
          approvalOrApply: 1,
        },
      })
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
